import { ApiPromise, WsProvider } from "@polkadot/api";
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

interface ApiState {
  api: ApiPromise;
  isReady: boolean;
}
export const ApiContext = createContext<ApiState>({} as unknown as ApiState);

export function ApiProvider({ children }: React.PropsWithChildren) {
  const [api, setApi] = useState({} as ApiPromise);
  const [isReady, setIsReady] = useState(false);

  const initializeProvider = async () => {
    const wsProvider = new WsProvider(
      import.meta.env.VITE_RPC_URL || "wss://rpc.timechain.analog.one"
    );
    const _api = new ApiPromise({ provider: wsProvider });
    _api.on("connected", async () => {
      await _api.isReady;
      console.log(`WS: connected`);
      setApi(_api);
      setIsReady(true);
    });
    _api.on("disconnected", () => {
      console.log("WS: disconnected");
      setIsReady(false);
    });
    return _api;
  };

  useEffect((): void => {
    let apiInstance: ApiPromise | null = null;

    initializeProvider().then((api) => {
      apiInstance = api;
    });

    const cleanup = () => {
      if (apiInstance) {
        console.log("Cleaning up API connection");
        apiInstance.disconnect();
      }
    };
    return cleanup();
  }, []);

  const value = useMemo(
    () => ({
      api,
      isReady,
    }),
    [api, isReady]
  );

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export const useApi = () => useContext(ApiContext);
